///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NodeFeature } from '../../../../logical-topology/entities/node/node-feature';
import { GtthHistoryService } from '../../../../logical-topology/engine/history-service';
import { GtthAltitudeModePipe } from '../pipes/altitude-mode.pipe';
import { GtthLayerDtoModel } from '../../../../../services/project-socket/dto/gtth-layer-dto.model';
import { GtthKeyValueDTO } from '../../../../../generated/shared-types.model';
import { GtthNodeFeatureDtoModel } from '../../../../../services/project-socket/dto/gtth-node-feature-dto.model';

@Component({
    selector: 'winde-origin-node',
    templateUrl: './origin-node.component.html',
    styleUrls: ['./origin-node.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [GtthAltitudeModePipe],
    standalone: false
})
export class GtthOriginNodeComponent implements OnInit {
    public readonly FROZEN_BADGE_TEXT = 'Frozen';
    public readonly ORIGIN_NOTE_BADGE_TEXT = 'Existing location';
    public name: string;
    public layerIndex: number;
    public latitude: number;
    public longitude: number;
    public height: number;
    public altitudeMode: string;
    public blockedByPoleAngle: number;
    public hasFreezeLinks: boolean;
    public layers: any;
    public unitOfMeasurement: string;
    @Input() origin: NodeFeature;
    private readonly FEET_MULTIPLIER = 0.3048;

    constructor(
        private readonly historyService: GtthHistoryService,
        private readonly altitudeModePipe: GtthAltitudeModePipe
    ) {}

    ngOnInit(): void {
        this.name = this.origin.getName();
        this.latitude = this.origin.getPosition().latitude;
        this.longitude = this.origin.getPosition().longitude;
        this.hasFreezeLinks = this.origin.hasFreezeLinks();
        this.layerIndex = this.origin.getLayerIndex();
        this.blockedByPoleAngle = this.origin.getBlockedByPoleAngle();
        if (this.blockedByPoleAngle === GtthNodeFeatureDtoModel.DEFAULT_POLE_BLOCKED_ANGLE) {
            this.blockedByPoleAngle = this.historyService.logicalTopology.autodesignP2mpPerLayer[this.origin.getLayerIndex()].pole_block;
        }

        this.unitOfMeasurement = this.historyService.logicalTopology.productUnits;
        this.layers = [];
        if (this.historyService.logicalTopology.layersModeEnabled) {
            this.layers = this.historyService.logicalTopology.layers.map((layer: GtthLayerDtoModel) => {
                return { key: layer.layerIndex, value: layer.getFullName() } as GtthKeyValueDTO;
            });
        }

        if (this.unitOfMeasurement === 'feet') {
            this.height = this.origin.getHeight() / this.FEET_MULTIPLIER;
        } else {
            this.height = this.origin.getHeight();
        }

        this.altitudeMode = this.altitudeModePipe.transform(this.origin.getAltitudeMode());
    }
}
